"use client"; // Indicate this is a client component

import React, { useEffect, useState } from "react";
import { Modal } from "@/components/_shared/Modal";
import PageLayout from "@/components/_shared/PageLayout";
import PasswortForm from "@/components/pw-generator/PasswortForm";

// Define the specific instructions for this page

export default function PasswortPage() {
	useEffect(() => {
		document.title = "Passwort Generator";
	}, []);

	return (
		<PageLayout
			additionalItemsToDelete={["passwort_pins"]}
			title="Passwort Generator"
			toolId="passwort"
		>
			<main className="grid grid-cols-1 gap-6">
				<PasswortForm />
			</main>
		</PageLayout>
	);
}
